import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/airbnb': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 373.1h0.1c24.7-31.2 39.6-58.9 45-83.2 22.6-88-112.6-88-90.1 0 4.9 23.8 19.8 51.5 45 83.2zM362.1 446.3c35.6-15.3 50.2-53.6 37-86.6-25.5-61.6-78.8-168.5-114.8-239.1-17-33.9-28-59.9-60.4-59.9-33.8 0-43.6 27.3-59.4 57.4-4.2 10.4-100.8 202.4-115.9 241.6-17.8 50 21.3 98.5 71.3 91.1 24.6-2.2 52.6-18.9 85.2-54.9-29.2-37.1-47.5-70.3-54.4-99.5-11.9-54 18.4-100.5 73.3-100.5 65 0 122.8 69.9 18.8 200 35.6 39.6 77.2 68.8 119.3 50.5zM409.1 310.2c0 0.7 16.8 35.7 16.8 39.6 25.2 69.3-26.7 130.2-89.6 130.2-11.1 0-53.7 1.4-112.4-62.4-51.8 56.3-90.7 62.4-112.4 62.4-62.9 0-114.8-60.9-89.6-130.2 0.9-2.6 11.2-32.7 117.3-245 19.8-41.1 39.1-72.8 84.7-72.8 49.1 0 56.3 3.9 185.2 278.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/airbnb.js
// module id = 700
// module chunks = 0